import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=25e20f8e&scoped=true"
import script from "./AttachmentUpload.vue?vue&type=script&lang=js"
export * from "./AttachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./AttachmentUpload.vue?vue&type=style&index=0&id=25e20f8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e20f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25e20f8e')) {
      api.createRecord('25e20f8e', component.options)
    } else {
      api.reload('25e20f8e', component.options)
    }
    module.hot.accept("./AttachmentUpload.vue?vue&type=template&id=25e20f8e&scoped=true", function () {
      api.rerender('25e20f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/components/AttachmentUpload.vue"
export default component.exports